export default function CheckRow({ checked, onToggle, title, subtitle, desc, time, tag, watchUrl, onEdit, onHistory, isCustom }) {
  return (
    <label className={`check-row ${checked ? 'is-checked' : ''}`}>
      <input type="checkbox" checked={!!checked} onChange={onToggle} />
      <span className="check-box" aria-hidden="true">
        {checked && (
          <svg width="14" height="14" viewBox="0 0 14 14">
            <polyline points="2.5,7.5 5.5,10.5 11.5,3.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </span>
      <span className="check-row-body">
        <span className="check-row-top">
          <span className="check-row-top-left">
            {time && <span className="check-row-time">{time}</span>}
            <span className="check-row-title">{title}</span>
            {isCustom && <span className="custom-badge">EDITED</span>}
          </span>
          {tag && <span className="check-row-tag">{tag}</span>}
        </span>
        {subtitle && <span className="check-row-subtitle">{subtitle}</span>}
        {desc && <span className="check-row-desc">{desc}</span>}
      </span>
      {watchUrl && (
        <a
          className="watch-link"
          href={watchUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          WATCH FORM ↗
        </a>
      )}
      {onHistory && (
        <button
          type="button"
          className="edit-link"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onHistory()
          }}
        >
          TREND
        </button>
      )}
      {onEdit && (
        <button
          type="button"
          className="edit-link"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onEdit()
          }}
        >
          EDIT
        </button>
      )}
    </label>
  )
}
